
import { observable, action, runInAction, } from 'mobx';
import { calculation, getJson, sum } from '@/method';
import { message } from 'antd';
import moment from 'moment';
import { dataDefault } from '../data';

const month = moment().format('M');
class store {
    @observable data = [];
    @observable forecast = [];
    @observable budget = [];
    @observable date = month < 3 ? moment().format('YYYY') : moment().add(1, 'y').format('YYYY');
    @observable loading = true;
    @observable dataAll = {};

    getData = async () => {
        let data = JSON.parse(JSON.stringify(dataDefault));
        let forecast = JSON.parse(JSON.stringify(dataDefault));
        let budget = JSON.parse(JSON.stringify(dataDefault));

        const date = this.date;
        runInAction(() => {
            this.loading = true;
        });
        try {
            let res = await fetch(`/efficiencyInfo?year=${moment(date).format('YYYY')}`, { credentials: 'include' });
            let x = await res.json();
            const { actualData = {}, forecastData = {}, budgetData = {}, b12 = [], b17 = [], b18 = [] } = x.data;
            if (actualData.data.length > 0) {
                data = actualData.data.sort((a, b) => a.sort - b.sort);
            }

            if (forecastData.data.length > 0) {
                forecast = forecastData.data.sort((a, b) => a.sort - b.sort);
            }

            if (budgetData.data.length > 0) {
                budget = budgetData.data.sort((a, b) => a.sort - b.sort);
            }

            data = await this.computeNum(data, { ...actualData, b12, b17, b18 }, 1);
            forecast = await this.computeNum(forecast, { ...forecastData, b12, b17, b18 }, 2);
            budget = await this.computeNum(budget, { ...budgetData, b12, b17, b18 }, 3);

            await runInAction(() => {
                this.data = data;
                this.forecast = forecast;
                this.budget = budget;
                this.loading = false;
                this.dataAll = x.data;
            });
            setTimeout(() => {
                this.onSave();
            }, 1000);

        } catch (error) {
            console.error(error);
            message.error('获取数据失败');
            runInAction(() => {
                this.loading = false;
            });

        }
    }

    @action
    onSave = () => {
        let data = [...this.data].map(x => ({ ...x, year: this.date }));
        let forecast = [...this.forecast].map(x => ({ ...x, year: this.date }));
        let budget = [...this.budget].map(x => ({ ...x, year: this.date }));

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        dataFrom.append('forecast', JSON.stringify(forecast));
        dataFrom.append('budget', JSON.stringify(budget));

        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/efficiencyAdd', headres).then(x => x.json()).then(x => {
            if (x.status != 1) message.error(x.msg);
        }).catch(err => {
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    @action
    onChangeDate = (str) => {
        this.date = str;
        this.data = [];
        this.forecast = [];
        this.budget = [];
        this.getData();
    }

    @action
    computeNum = (data,
        { b12, b17, b18, meet, rooms, t12 = {}, t17 = {}, inter_rooms, inter_meet, inter12, inter17 },
        type = 1) => {
        const name = type == 1 ? 'before_revenue' : type == 2 ? "last_revenue" : "year_revenue";
        const name18 = type == 1 ? 'before' : type == 2 ? "last_end" : "year_end";

        const days = moment(this.date).subtract(3 - type, 'year').isLeapYear() ? 366 : 365;
        // 区域数据
        data[0].area = calculation(rooms, t17.Room * days, 2);
        data[1].area = calculation(sum([t12.Banquet, t12.Meeting]), meet * days, 2);
        data[4].area = calculation(t12.Cafe, t17.AllDay_num * days, 2);
        data[5].area = calculation(t12.Cafe, t17.AllDay * days, 2);
        data[6].area = calculation(t12.Chinese, t17.Chinese_num * days, 2);
        data[7].area = calculation(t12.Chinese, t17.Chinese * days, 2);
        data[8].area = calculation(t12.Lobby, t17.Lounge_num * days, 2);
        data[9].area = calculation(t12.Lobby, t17.Lounge * days, 2);
        data[10].area = calculation(t12.Specialty, t17.Special_num * days, 2);
        data[11].area = calculation(t12.Specialty, t17.Special * days, 2);
        data[12].area = calculation(t12.Other, sum([t17.Other_num, t17.B_num]) * days, 2);
        data[13].area = calculation(t12.Other, sum([t17.Other, t17.B]) * days, 2);
        data[2].area = calculation(
            sum([t12.Cafe, t12.Chinese, t12.Lobby, t12.Specialty, t12.Other]),
            sum([t17.Chinese_num, t17.AllDay_num, t17.Lounge_num, t17.Special_num, t17.Other_num, t17.B_num, t17.private_num]) * days,
            2
        );
        data[3].area = calculation(
            sum([t12.Cafe, t12.Chinese, t12.Lobby, t12.Specialty, t12.Other]),
            sum([t17.Chinese, t17.AllDay, t17.Lounge, t17.Special, t17.Other, t17.B, t17.private]) * days,
            2
        );

        // 收入区间数据 
        data[0].interval = calculation(inter_rooms, inter17.Room * days, 2);
        data[1].interval = calculation(sum([inter12.Banquet, inter12.Meeting]), inter_meet * days, 2);
        data[4].interval = calculation(inter12.Cafe, inter17.AllDay_num * days, 2);
        data[5].interval = calculation(inter12.Cafe, inter17.AllDay * days, 2);
        data[6].interval = calculation(inter12.Chinese, inter17.Chinese_num * days, 2);
        data[7].interval = calculation(inter12.Chinese, inter17.Chinese * days, 2);
        data[8].interval = calculation(inter12.Lobby, inter17.Lounge_num * days, 2);
        data[9].interval = calculation(inter12.Lobby, inter17.Lounge * days, 2);
        data[10].interval = calculation(inter12.Specialty, inter17.Special_num * days, 2);
        data[11].interval = calculation(inter12.Specialty, inter17.Special * days, 2);
        data[12].interval = calculation(inter12.Other, sum([inter17.Other_num, inter17.B_num]) * days, 2);
        data[13].interval = calculation(inter12.Other, sum([inter17.Other, inter17.B]) * days, 2);
        data[2].interval = calculation(
            sum([inter12.Cafe, inter12.Chinese, inter12.Lobby, inter12.Specialty, inter12.Other]),
            sum([inter17.Chinese_num, inter17.AllDay_num, inter17.Lounge_num, inter17.Special_num, inter17.Other_num, inter17.B_num, inter17.private_num]) * days,
            2
        );
        data[3].interval = calculation(
            sum([inter12.Cafe, inter12.Chinese, inter12.Lobby, inter12.Specialty, inter12.Other]),
            sum([inter17.Chinese, inter17.AllDay, inter17.Lounge, inter17.Special, inter17.Other, inter17.B, inter17.private]) * days,
            2
        );

        // 酒店数据
        data[0].hotel = calculation(getJson([7, name18], b18), getJson([2, 'rooms_fb_num'], b17) * days, 2);
        data[1].hotel = calculation(
            sum([getJson([7, name], b12), getJson([11, name], b12)]),
            getJson([19, 'conference_num'], b17) * days,
            2
        );
        data[4].hotel = calculation(getJson([2, name], b12), getJson([12, 'rooms_fb_num'], b17) * days, 2);
        data[5].hotel = calculation(getJson([2, name], b12), getJson([13, 'rooms_fb_num'], b17) * days, 2);
        data[6].hotel = calculation(getJson([3, name], b12), getJson([8, 'rooms_fb_num'], b17) * days, 2);
        data[7].hotel = calculation(getJson([3, name], b12), getJson([9, 'rooms_fb_num'], b17) * days, 2);
        data[8].hotel = calculation(getJson([6, name], b12), getJson([14, 'rooms_fb_num'], b17) * days, 2);
        data[9].hotel = calculation(getJson([6, name], b12), getJson([15, 'rooms_fb_num'], b17) * days, 2);
        data[10].hotel = calculation(getJson([4, name], b12), getJson([16, 'rooms_fb_num'], b17) * days, 2);
        data[11].hotel = calculation(getJson([4, name], b12), getJson([17, 'rooms_fb_num'], b17) * days, 2);
        data[12].hotel = calculation(getJson([10, name], b12), sum([getJson([18, 'rooms_fb_num'], b17), getJson([20, 'rooms_fb_num'], b17)]) * days, 2);
        data[13].hotel = calculation(getJson([10, name], b12), sum([getJson([19, 'rooms_fb_num'], b17), getJson([21, 'rooms_fb_num'], b17)]) * days, 2);

        data[2].hotel = calculation(
            sum([getJson([2, name], b12), getJson([3, name], b12), getJson([4, name], b12), getJson([6, name], b12), getJson([10, name], b12)]),
            sum([getJson([8, 'rooms_fb_num'], b17), getJson([12, 'rooms_fb_num'], b17), getJson([14, 'rooms_fb_num'], b17), getJson([16, 'rooms_fb_num'], b17), getJson([18, 'rooms_fb_num'], b17), getJson([20, 'rooms_fb_num'], b17), getJson([10, 'rooms_fb_num'], b17)]) * days,
            2
        );
        data[3].hotel = calculation(
            sum([getJson([2, name], b12), getJson([3, name], b12), getJson([4, name], b12), getJson([6, name], b12), getJson([10, name], b12)]),
            sum([getJson([9, 'rooms_fb_num'], b17), getJson([13, 'rooms_fb_num'], b17), getJson([15, 'rooms_fb_num'], b17), getJson([17, 'rooms_fb_num'], b17), getJson([19, 'rooms_fb_num'], b17), getJson([21, 'rooms_fb_num'], b17), getJson([11, 'rooms_fb_num'], b17)]) * days,
            2
        );
        return data
    }
}

const Actual = new store();

export default Actual;


// WEBPACK FOOTER //
// ./src/components/table/effect/store/actual.js